export default __webpack_public_path__ + "static/media/hht1_ep1_minisitcom_04.ccc9d427.png";